<template> 
  <div id="app"> 
    <v-app> 
      <v-main>
        <router-view/>
      </v-main>
    </v-app> 
  </div> 
</template>

<style>
  @import 'material_icons/material-icons.css';
</style>
<script> 
export default { 
  name: "App", 
  data() { 
    return {}; 
  } 
}; 
</script>
